// Remember the active Paper Edit interview per account and project.
// This is local UI preference only; it never modifies transcript, story or XML.
const key=(userId,projectId)=>userId&&projectId?`takefold-paper-interview:${userId}:${projectId}`:null;
export function recallPaperInterview(storage,userId,projectId,validIds){
 const k=key(userId,projectId);
 if(!k || !Array.isArray(validIds) || !validIds.length)return null;
 try{const id=storage?.getItem(k);return id&&validIds.includes(id)?id:null;}catch{return null;}
}
export function storePaperInterview(storage,userId,projectId,interviewId){
 const k=key(userId,projectId);
 if(!k || !interviewId)return false;
 try{storage?.setItem(k,interviewId);return true;}catch{return false;}
}
export function resolvePaperInterview(explicitId,storedId,validIds,rootId){
 if(explicitId && validIds.includes(explicitId))return explicitId;
 if(storedId && validIds.includes(storedId))return storedId;
 return rootId||'';
}
